import localForage from "localforage";
import type { StateStorage } from "zustand/middleware";

/**
 * The localForage adapter of the React Query persister. `satisfies` rather than an annotation: zustand's `StateStorage`
 * widens the return types to `unknown`, which the persister's `AsyncStorage` rejects.
 */
export const localForageStorage = {
  getItem: (name: string) => localForage.getItem<string>(name),
  setItem: async (name: string, value: string) => {
    await localForage.setItem(name, value);
  },
  removeItem: async (name: string) => {
    await localForage.removeItem(name);
  },
} satisfies StateStorage;
